<template>

  <b-sidebar
    id="sidebar-create-org-monitoring"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ orgMonitoring.id ? $t('Update'): $t('Create') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="orgMonitoringCreate">
          <!-- Uz Name -->
          <b-form-group
            :label="$t('Periods')"
            label-for="period"
          >
            <v-select
              id="period"
              v-model="orgMonitoring.period"
              :disabled="!!orgMonitoring.id"
              :reduce="(option) => option.id"
              :options="periodOptions"
              label="admission_year"
              @input="setClear"
            />
          </b-form-group>
          <b-form-group
            :label="$t('Quarter')"
            label-for="quarter"
          >
            <v-select
              id="quarter"
              v-model="orgMonitoring.quarter"
              :disabled="!!orgMonitoring.id"
              :reduce="(option) => option.id"
              :options="quarters"
              label="quarter"
            />
          </b-form-group>
          <b-form-group
            :label="$t('File')"
            label-for="file"
          >
            <div
              v-if="orgMonitoring.file"
              class="input-group"
            >
              <div class="input-group-prepend">
                <span class="input-group-text border-success">
                  <b-link
                    :href="orgMonitoring.file"
                    download="file"
                    target="_blank"
                  >
                    <feather-icon
                      icon="DownloadIcon"
                      class="cursor-pointer"
                      size="16"
                    />
                  </b-link>

                </span>
              </div>
              <div
                class="form-control border-success"
              >
                {{ $t('File') }}
              </div>
              <div
                class="input-group-append"
              >
                <span class="input-group-text">
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer danger"
                    size="16"
                    @click="cancel"
                  />
                </span>
              </div>
            </div>
            <validation-provider
              v-else
              #default="{ errors }"
              :name="$t('File')"
              rules="file-size:10"
            >
              <b-form-file
                v-model="orgMonitoring.file_upload"
                :placeholder="$t('Choose a file or drop it here...')"
                accept="application/pdf"
                :drop-placeholder="$t('Drop file here...')"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        <!-- Form Actions -->
        </validation-observer>
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ orgMonitoring.id ? $t('Update'):$t('Create') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>
<script>
import {
  BButton, BForm, BFormFile, BFormGroup, BLink, BSidebar,
} from 'bootstrap-vue'
import { localize, ValidationObserver, ValidationProvider } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { fileSize, required } from '@/libs/validations/validations'

export default {
  name: 'Create',
  directives: {
    Ripple,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    BSidebar,
    BForm,
    BFormGroup,
    BFormFile,
    BButton,
    vSelect,
    BLink,
  },
  data() {
    return {
      required,
      fileSize,
      quarters: [],
    }
  },
  computed: {
    periodOptions: {
      get() {
        return this.$store.state.staticModule.periodList
      },
    },
    orgMonitoring: {
      get() {
        return this.$store.state.orgMonitoring.orgMonitoring
      },
    },
  },
  mounted() {
    this.loadData()
  },
  created() {
    localize(this.$i18n.locale)
    this.$store.commit('orgMonitoring/FRESH')
  },
  methods: {
    loadData() {
      this.$store.dispatch('staticModule/periodList')
    },
    setClear(e) {
      this.quarters = []
      this.orgMonitoring.quarter = null
      this.loadQuarters(e)
    },
    loadQuarters(e) {
      if (e) this.quarters = this.getPeriod(e).quarters ?? []
    },
    clear(hide) {
      this.$store.commit('orgMonitoring/FRESH')
      this.$refs.orgMonitoringCreate.reset()
      hide()
    },
    getPeriod(id) {
      return this.$store.getters['staticModule/getPeriod'](id)
    },
    cancel() {
      this.orgMonitoring.file = null
      this.orgMonitoring.file_upload = null
    },
    submit(hide) {
      this.$refs.orgMonitoringCreate.validate().then(success => {
        if (success) {
          this.$createSwal(this, this.orgMonitoring, 'orgMonitoring/createOrUpdate', () => {
            this.$emit('refetchData')
            this.$store.commit('orgMonitoring/FRESH')
          })
          hide()
        }
      })
    },
  },
  setup() {
  },
}
</script>

  <style scoped />
